// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fDnAm","boldText":"styles_boldText__s+9pT","whiteAndRoundedBackgroundWrapper":"styles_whiteAndRoundedBackgroundWrapper__ZPRxo"};